import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {DownloadCsvActions, DownloadCsvFailure, DownloadCsvSuccess} from '../actions/download-csv.actions';
import {switchMap} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {of} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {ExportFileService} from '../../service/export-file.service';

@Injectable()
export class DownloadCsvEffects {
    downloadCsv$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DownloadCsvActions.downloadCsv),
            switchMap((action: { blob: HttpResponse<Blob> }) => {
                try {
                    this.exportFileService.downloadFile(action.blob)
                    this.toastService.success('Downloaded of CSV successfully');
                    return of(DownloadCsvSuccess({res: action.blob}))
                } catch (error) {
                    return of(DownloadCsvFailure(error))
                }
            })
        )
    );

    constructor(
        private actions$: Actions,
        private exportFileService: ExportFileService,
        private toastService: ToastrService,
    ) {}
}



